/** 时间转化为星期几
 * @param {Date} date 需要处理的时间
 */

export default function (time) {
  const str = '周'
  let date =
    time instanceof Date ? time : typeof time === 'number' || typeof time === 'string' ? new Date(time) : new Date((time || '').replace(/-/g, '/'))
  let today = new Date()
  let diff = (date.getTime() - today.getTime()) / 1000
  let dayDiff = Math.ceil(diff / 86400)
  /* eslint no-mixed-operators: 0 */
  return (dayDiff === 0 && '今天') || (dayDiff === 1 && '明天') || (dayDiff === 2 && '后天') || str + '日一二三四五六'.charAt(date.getDay())
}
